















import { Component, Prop, Vue } from 'vue-property-decorator';

import FilterTag from '@/componentsV2/molecules/FilterTag/FilterTag.vue';
import {
  EInitiativesDictionary,
  InitiativeThemeDictionary
} from '@/models/initiatives';

import PerformanceUtils from '@/utils/PerformanceUtils';

export type Tag = {
  type: string;
  label: string;
  tooltipText?: string;
};

@Component({
  components: {
    FilterTag
  }
})
export default class FilterByTags extends Vue {
  @Prop({ default: () => [] }) filteredTags?: string[];
  @Prop({ default: () => [] }) tags!: Tag[];
  @Prop({ default: true }) showOnlyAvailableRoutes?: boolean;
  @Prop({ default: false }) defaultTheme?: boolean;
  @Prop({ default: true }) multiSelected?: boolean;

  get tagItems() {
    if (!this.showOnlyAvailableRoutes) return this.tags;

    return PerformanceUtils.filteredDataBySlug(this.tags, 'type');
  }

  getTheme(tag: Tag) {
    if (
      this.defaultTheme ||
      !InitiativeThemeDictionary[
        tag.type as keyof typeof InitiativeThemeDictionary
      ]
    )
      return EInitiativesDictionary.DEFAULT;

    return tag.type;
  }

  getClassInactive(tag: Tag) {
    const notSelected =
      this.filteredTags &&
      this.filteredTags.length > 0 &&
      !this.filteredTags.includes(tag.type);

    if (!this.multiSelected && notSelected) return '--inactive';
    return '';
  }
}
